import * as ambassadorWixAutomationsTemplatesV1AutomationTemplate from './automations-templates-v1-automation-template-automation-templates.http.js';
import * as ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes from './automations-templates-v1-automation-template-automation-templates.types.js';
import * as ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes from './automations-templates-v1-automation-template-automation-templates.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createAutomationTemplate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.CreateAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.CreateAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.CreateAutomationTemplateResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.CreateAutomationTemplateResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.createAutomationTemplate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/automation-templates',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAutomationTemplate(): __PublicMethodMetaInfo<
  'GET',
  { automationTemplateId: string },
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.GetAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.GetAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.GetAutomationTemplateResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.GetAutomationTemplateResponse
> {
  const payload = { automationTemplateId: ':automationTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.getAutomationTemplate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/automation-templates/{automationTemplateId}',
    pathParams: { automationTemplateId: 'automationTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAutomationTemplate(): __PublicMethodMetaInfo<
  'PATCH',
  { automationTemplateId: string },
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.UpdateAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.UpdateAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.UpdateAutomationTemplateResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.UpdateAutomationTemplateResponse
> {
  const payload = {
    automationTemplate: { id: ':automationTemplateId' },
  } as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.updateAutomationTemplate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/automation-templates/{automationTemplate.id}',
    pathParams: { automationTemplateId: 'automationTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAutomationTemplate(): __PublicMethodMetaInfo<
  'DELETE',
  { componentId: string },
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.DeleteAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.DeleteAutomationTemplateRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.DeleteAutomationTemplateResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.DeleteAutomationTemplateResponse
> {
  const payload = { componentId: ':componentId' } as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.deleteAutomationTemplate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/automation-templates/{componentId}',
    pathParams: { componentId: 'componentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resolveAutomationTemplates(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.ResolveAutomationTemplatesRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.ResolveAutomationTemplatesRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.ResolveAutomationTemplatesResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.ResolveAutomationTemplatesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.resolveAutomationTemplates(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/automation-templates/resolve',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAutomationTemplatesForApp(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.QueryAutomationTemplatesForAppRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.QueryAutomationTemplatesForAppRequest,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateUniversalTypes.QueryAutomationTemplatesForAppResponse,
  ambassadorWixAutomationsTemplatesV1AutomationTemplateTypes.QueryAutomationTemplatesForAppResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTemplatesV1AutomationTemplate.queryAutomationTemplatesForApp(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/automation-templates/query-for-app',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AutomationTemplate as AutomationTemplateOriginal,
  Category as CategoryOriginal,
  CategoryWithLiterals as CategoryWithLiteralsOriginal,
  Automation as AutomationOriginal,
  AutomationOriginInfoOneOf as AutomationOriginInfoOneOfOriginal,
  AIMetadata as AIMetadataOriginal,
  ActionSettings as ActionSettingsOriginal,
  Domain as DomainOriginal,
  DomainWithLiterals as DomainWithLiteralsOriginal,
  TriggerSettings as TriggerSettingsOriginal,
  Enrichment as EnrichmentOriginal,
  AuditInfo as AuditInfoOriginal,
  AuditInfoIdOneOf as AuditInfoIdOneOfOriginal,
  AutomationConfiguration as AutomationConfigurationOriginal,
  TimeUnit as TimeUnitOriginal,
  TimeUnitWithLiterals as TimeUnitWithLiteralsOriginal,
  Filter as FilterOriginal,
  FutureDateActivationOffset as FutureDateActivationOffsetOriginal,
  RateLimit as RateLimitOriginal,
  FilterValueSelection as FilterValueSelectionOriginal,
  ConditionExpressionGroup as ConditionExpressionGroupOriginal,
  Operator as OperatorOriginal,
  OperatorWithLiterals as OperatorWithLiteralsOriginal,
  CodeSnippet as CodeSnippetOriginal,
  Language as LanguageOriginal,
  LanguageWithLiterals as LanguageWithLiteralsOriginal,
  Path as PathOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  AppDefinedAction as AppDefinedActionOriginal,
  ConditionAction as ConditionActionOriginal,
  CodeConditionAction as CodeConditionActionOriginal,
  DelayAction as DelayActionOriginal,
  RateLimitAction as RateLimitActionOriginal,
  SetVariablesAction as SetVariablesActionOriginal,
  OutputAction as OutputActionOriginal,
  SplitAction as SplitActionOriginal,
  MergeAction as MergeActionOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Trigger as TriggerOriginal,
  Action as ActionOriginal,
  ActionInfoOneOf as ActionInfoOneOfOriginal,
  FilterableAppDefinedActions as FilterableAppDefinedActionsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  ApplicationOrigin as ApplicationOriginOriginal,
  PreinstalledOrigin as PreinstalledOriginOriginal,
  TemplateOrigin as TemplateOriginOriginal,
  AutomationSettings as AutomationSettingsOriginal,
  DraftInfo as DraftInfoOriginal,
  Enrichments as EnrichmentsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  AutoArchivePolicy as AutoArchivePolicyOriginal,
  Notes as NotesOriginal,
  Note as NoteOriginal,
  Position as PositionOriginal,
  Offset as OffsetOriginal,
  Dimensions as DimensionsOriginal,
  CategoryInfo as CategoryInfoOriginal,
  SegmentInfo as SegmentInfoOriginal,
  AutomationTemplateDeletedWithEntity as AutomationTemplateDeletedWithEntityOriginal,
  CreateAutomationTemplateRequest as CreateAutomationTemplateRequestOriginal,
  AutomationTemplateSpecInfo as AutomationTemplateSpecInfoOriginal,
  CreateAutomationTemplateResponse as CreateAutomationTemplateResponseOriginal,
  GetAutomationTemplateRequest as GetAutomationTemplateRequestOriginal,
  GetAutomationTemplateResponse as GetAutomationTemplateResponseOriginal,
  UpdateAutomationTemplateRequest as UpdateAutomationTemplateRequestOriginal,
  UpdateAutomationTemplateResponse as UpdateAutomationTemplateResponseOriginal,
  DeleteAutomationTemplateRequest as DeleteAutomationTemplateRequestOriginal,
  DeleteAutomationTemplateResponse as DeleteAutomationTemplateResponseOriginal,
  ResolveAutomationTemplatesRequest as ResolveAutomationTemplatesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  CommonSorting as CommonSortingOriginal,
  CommonSortOrder as CommonSortOrderOriginal,
  CommonSortOrderWithLiterals as CommonSortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  CommonCursorPaging as CommonCursorPagingOriginal,
  ResolveAutomationTemplatesResponse as ResolveAutomationTemplatesResponseOriginal,
  CommonCursorPagingMetadata as CommonCursorPagingMetadataOriginal,
  CommonCursors as CommonCursorsOriginal,
  QueryAutomationTemplatesForAppRequest as QueryAutomationTemplatesForAppRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAutomationTemplatesForAppResponse as QueryAutomationTemplatesForAppResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './automations-templates-v1-automation-template-automation-templates.types.js';
